export default "__VITE_ASSET__d89b9e3f__"